import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Privacy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-container">
      <h1>Special Thanks</h1>
      <p>
        Thank you to the following <span className="gold-text">donators</span>:
      </p>

      <div className="donators-list">
        <div className="donator">
          <img src="/images/asuto.webp" alt="Asuto" className="donator-avatar" />
          <div className="donator-text">
            <p>
              <span className="gold-text">Charlie Hamer</span> – Thank you for helping to keep the website running!{' '}
              <span className="reddit-user">
              <img src="/images/reddit.webp" alt="Reddit" className="reddit" />
              <span className="reddit-name">Flame493</span>
            </span>
            </p>
          </div>
        </div>
      </div>

      <p>
        Also thank you to all of you who play <span className="gold-text">Inazumadle</span>!!
      </p>

      <p>
        You can go back to the game by clicking{' '}
        <Link to="/" className="support-link">
          here
        </Link>.
      </p>

      <img src="/images/arion.png" alt="Fei" className="thanks-image" />
    </div>
  );
}
